import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";

import "./styles/MultipleSelect.styles.css";
import { Text } from "@aws-amplify/ui-react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const MultipleSelect = ({ values, placeholder, options, onChange }) => {
  const onChangeStatus = (event) => {
    const {
      target: { value },
    } = event;
    onChange(value);
  };

  return (
    <FormControl>
      <Select
        labelId="multiple-select-status"
        multiple
        value={values}
        onChange={onChangeStatus}
        displayEmpty
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <Text className="text-muted">{placeholder}</Text>;
          }

          return selected
            .map((sel) => options.find((opt) => sel === opt.value)?.label || "")
            .join(", ");
        }}
        MenuProps={MenuProps}
      >
        <MenuItem disabled value="">
          <Text className="text-muted">{placeholder}</Text>
        </MenuItem>
        {options?.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            <Checkbox checked={values?.includes(opt.value)} />
            <ListItemText primary={opt.label} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleSelect;
